module.exports = __webpack_public_path__ + "img/class0.beb35a5a.png";